import { Routes } from '@angular/router';
import { LoginPage } from './pages/login/login.page';
import { DashboardPage } from './pages/dashboard/dashboard.page';
import { DownloadResourcesPage } from './pages/download-resources/download-resources.page';
import { CreateNewUserPage } from './pages/create-new-user/create-new-user.page';
import { ManageUsersPage } from './pages/manage-users/manage-users.page';
import { ForgotPasswordPage } from './pages/forgot-password/forgot-password.page';
import { RegisterNewUsersPage } from './pages/register-new-users/register-new-users.page';
import { PageNotFoundPage } from './pages/page-not-found/page-not-found.page';

export const routes: Routes = [
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'login', component: LoginPage, data: { title: 'Login' } },
    { path: 'forgot-password', component: ForgotPasswordPage, data: { title: 'Forgot Password' } },
    { path: 'dashboard', component: DashboardPage, data: { title: 'Dashboard' } },
    { path: 'download-resources', component: DownloadResourcesPage, data: { title: 'Download Resources' } },
    { path: 'user/create-new-user', component: CreateNewUserPage, data: { title: 'Create New User' } },
    { path: 'user/manage-user', component: ManageUsersPage, data: { title: 'Manage Users' } },
    { path: 'register-new-user', component: RegisterNewUsersPage, data: { title: 'Register/Onboard' } },
    { path: 'page-not-found', component: PageNotFoundPage, data: { title: 'Page Not Found' } },

    { path: '**', redirectTo: 'page-not-found', pathMatch: 'full' }
];
